module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "uGgZAvUHI5BjGeJOmal4MvC"
    }
  }, [_c('p', {
    staticClass: "CHAPTER-SUB"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER-SUB"
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH---Space"
  }, [_vm._v("This novel is a work of fiction, any resemblance to persons living or dead is purely coincidental; however, the author has taken the liberty of using historical characters, references and places to enhance the reader experience.")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH---Space"
  }, [_vm._v("References to known and convicted criminals, along with political figures and places have been added to enhance the story and lend realism to the fictional tale contained in this story.")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH---Space"
  }, [_vm._v("References to police departments or bureaus of investigation, including local, state and federal are a fictional account. This story does not reflect in any way on the organizations mentioned or their level of professionalism. This is a fictional tale as are the characters and events, any resemblance is again purely coincidental. ")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH---Space"
  }, [_vm._v("Any omission or error rests solely with the author.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56e28c86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/AuthorNote.vue
// module id = 69
// module chunks = 0